export default __webpack_public_path__ + "static/media/spinnaker_550_340.38b045ce.jpg";